// File: components/DutyList/UrduPrintable.js
import React from "react";

const thStyle = {
  padding: "12px",
  border: "1px solid #ccc",
  textAlign: "center",
  backgroundColor: "#0d6efd",
  color: "#fff",
};

const tdStyle = {
  padding: "10px",
  border: "1px solid #ccc",
  textAlign: "center",
};

const UrduPrintable = ({ loading, urduData, readableDate, printRef }) => {
  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };

  return (
    <div className="container mt-5">
      <div className="d-flex justify-content-between align-items-center">
        <h5>📄 ڈیوٹی روسٹر (اردو)</h5>
        <button className="btn btn-outline-success btn-sm me-2" onClick={handlePrint} disabled={loading}>
          🖨️ پرنٹ کریں
        </button>
      </div>

      <div
        ref={printRef}
        style={{
          fontFamily: "'Jameel Noori Nastaleeq', serif",
          direction: "rtl",
          background: "#fff",
          padding: "30px",
          margin: "auto",
          maxWidth: "1000px",
          boxShadow: "0 0 10px rgba(0,0,0,0.15)",
          borderRadius: "10px",
          border: "1px solid #e3e3e3",
        }}
      >
        <h2 style={{ textAlign: "center", color: "#0d6efd", marginBottom: 5 }}>
          راولپنڈی انسٹیٹیوٹ آف کارڈیالوجی
        </h2>
        <h4 style={{ textAlign: "center", marginBottom: 10 }}>ڈیوٹی روسٹر</h4>
        <p style={{ textAlign: "center", marginBottom: 25 }}>
          📅 تاریخ: <strong>{readableDate}</strong>
        </p>

        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "18px" }}>
          <thead>
            <tr>
              <th style={thStyle}>نمبر</th>
              <th style={thStyle}>ڈیوٹی کا شعبہ</th>
              <th style={thStyle}>نام</th>
              <th style={thStyle}>رابطہ نمبر</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="4" style={{ textAlign: "center", padding: 30 }}>
                  ترجمہ ہو رہا ہے...
                </td>
              </tr>
            ) : urduData.length > 0 ? (
              urduData.map((r, i) => (
                <tr
                  key={i}
                  style={{ backgroundColor: i % 2 === 0 ? "#f0f8ff" : "#ffffff" }}
                >
                  <td style={tdStyle}>{r.no}</td>
                  <td style={tdStyle}>{r.on_call}</td>
                  <td style={tdStyle}>{r.name}</td>
                  <td style={tdStyle}>{r.contact}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" style={{ textAlign: "center", padding: "15px" }}>
                  📭 کوئی ریکارڈ موجود نہیں
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UrduPrintable;
